import React, { FC } from "react"
import styled from "styled-components"
import { Container } from "styled-bootstrap-grid"
import arrowForwardIcon from "../../../static/icons/ic_36_arrows_forward_back.svg"
import buildingIcon from "../../../static/icons/ic_36_building.svg"
import contactsIcon from "../../../static/icons/ic_36_contacts.svg"
import manIcon from "../../../static/icons/ic_36_man_badge.svg"
import percentIcon from "../../../static/icons/ic_36_percent.svg"
import documentIcon from "../../../static/icons/ic_36_document.svg"

const SubMenuStyles = styled.div`
  border-bottom: 1px solid #eaeaea;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    display: none;
  }
`

const LinkStyle = styled.div`
  text-align: center;
  padding-top: 14px;
  padding-bottom: 16px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #2d3033;
  }
  p {
    font-size: 14px;
    line-height: 15px;
  }

  border-bottom: 2px transparent solid;

  &:hover {
    border-bottom: 2px #18bb4f solid;
  }
`

interface ILink {
  icon?: string | React.ReactNode
  to?: string
}

interface ILinkProps extends ILink {
  text?: string
}

const Link: FC<ILink> = ({ icon, children, to }) => {
  return (
    <LinkStyle>
      <a href={to}>
        {icon}
        <p>{children}</p>
      </a>
    </LinkStyle>
  )
}

const links: ILinkProps[] = [
  {
    icon: <img src={percentIcon} alt="percent" />,
    to: "https://npfsberbanka.ru/ipp/",
    text: "Индивидуальный пенсионный план",
  },
  {
    icon: <img src={arrowForwardIcon} alt="arrow" />,
    to: "https://npfsberbanka.ru/ops/",
    text: "Перевести накопления в НПФ",
  },
  {
    icon: <img src={manIcon} alt="man" />,
    to: "https://npfsberbanka.ru/business/",
    text: "Корпоративным клиентам",
  },
  {
    icon: <img src={buildingIcon} alt="building" />,
    to: "https://npfsberbanka.ru/about/",
    text: "О фонде",
  },
  {
    icon: <img src={contactsIcon} alt="contacts" />,
    to: "https://npfsberbanka.ru/contacts/",
    text: "Контакты",
  },
]

export const HeaderSubMenu: FC = () => {
  return (
    <SubMenuStyles>
      <Container>
        <div className="header-submenu">
          {links.map(({ text, ...rest }, index) => (
            <Link {...rest} key={index}>
              {text}
            </Link>
          ))}
        </div>
      </Container>
    </SubMenuStyles>
  )
}
